import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import fr from './locales/fr.json';

export const SUPPORTED_LANGUAGES = ['fr', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: 'fr',
    supportedLngs: SUPPORTED_LANGUAGES,
    // Le navigateur annonce « en-US »/« fr-FR » : sans ceci, aucune variante
    // régionale ne matche ['fr','en'] et TOUT le monde retombait sur le
    // français. Désormais la langue suit réellement celle du navigateur.
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: {
      // React échappe déjà les valeurs interpolées.
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
  });

// Garde l'attribut lang du document aligné avec la langue active (a11y + SEO).
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
